// extracted by mini-css-extract-plugin
export default {"operateSensorConfig":"operateModal_operateSensorConfig__Wlosv","formBox":"operateModal_formBox__HQpuw","imageBox":"operateModal_imageBox__yIipx"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"operateSensorConfig\":\"operateModal_operateSensorConfig__Wlosv\",\"formBox\":\"operateModal_formBox__HQpuw\",\"imageBox\":\"operateModal_imageBox__yIipx\"}";
        // 1793842504640
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  